import { createSlice } from "@reduxjs/toolkit";
import {
  getCompanyDetailsThunk,
  addCompanyDetailsThunk,
  updateCompanyDetailsThunk,
} from "../thunks/companyDetailsThunks";

const initialState = {
  companyDetails: null,
  loading: false,
  error: null,
};

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetails = action.payload;
      })
      .addCase(getCompanyDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addCompanyDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCompanyDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetails = action.payload;
      })
      .addCase(addCompanyDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCompanyDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCompanyDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.companyDetails = action.payload;
      })
      .addCase(updateCompanyDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default companyDetailsSlice.reducer;
